"use client";

import { useWeb3 } from "logic/components";
import { type Address, erc20Abi, zeroAddress } from "viem";

import { useContractView } from "../contracts";

interface UseERC20BalanceParams {
  erc20Address: Address | undefined;
  watch?: boolean;
  chainId?: number;
  enabled?: boolean;
}

export function useERC20Balance(params: UseERC20BalanceParams | undefined) {
  const { erc20Address, watch, chainId, enabled = true } = params ?? {};

  const { address = zeroAddress } = useWeb3();

  const isConnected = address != zeroAddress;

  const { data, isError, ...rest } = useContractView(
    params && {
      address: erc20Address,
      abi: erc20Abi,
      functionName: "balanceOf",
      args: [address],
      watch,
      chainId,
      query: {
        enabled: enabled && isConnected && erc20Address != zeroAddress,
      },
    },
  );

  if (!isConnected) return { data: null, isError, ...rest };
  if (isError) return { data: null, isError, ...rest };
  return { data, isError, ...rest };
}
